interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  const add = (p: number | string) => pages.push(p);

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) add(i);
  } else if (page <= 4) {
    for (let i = 1; i <= 5; i += 1) add(i);
    add('...');
    add(totalPages);
  } else if (page >= totalPages - 3) {
    add(1);
    add('...');
    for (let i = totalPages - 4; i <= totalPages; i += 1) add(i);
  } else {
    add(1);
    add('...');
    add(page - 1);
    add(page);
    add(page + 1);
    add('...');
    add(totalPages);
  }

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-9 px-3 inline-flex items-center gap-1 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true" />
        上一页
      </button>

      {pages.map((p, i) =>
        typeof p === 'number' ? (
          <button
            key={i}
            type="button"
            onClick={() => onChange(p)}
            className={`w-9 h-9 rounded-md font-label text-sm transition-colors cursor-pointer ${
              p === page
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300'
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={i} className="w-9 h-9 flex items-center justify-center text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-9 px-3 inline-flex items-center gap-1 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
      </button>
    </div>
  );
}